// Declare imports out of the main theme file to avoid errors with `yarn`.
// See https://chakra-ui.com/docs/theming/advanced.
import '@fontsource/poppins'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/500.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'
import '@fontsource/poppins/900.css'
